import styled from 'styled-components';

export const Style = styled.div`
  position: sticky;
  bottom: 0;
  .footerWrap {
    display: none;
  }

  @media (max-width: 1200px) {
    .footerWrap {
      display: flex;
      border-top: 1px solid #efefef;
      background: #fff;
      a {
        position: relative;
        flex: 1;
        padding: 8px 4px;
        text-align: center;
        img {
          width: 20px;
          height: 20px;
        }
        h3 {
          font-size: 12px;
          line-height: 16px;
          color: #555;
        }
      }
      a.active {
        h3 {
          color: #4dd2ae;
        }
      }
      .countWrap {
        position: absolute;
        top: -5px;
        left: 50%;
        transform: translateX(30%);
        width: 20px;
        height: 20px;
        background: #ff6060;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          font-size: 12px;
          line-height: 12px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }
`;
